import React, { createContext, useState, useEffect } from "react";

export const LocationsContext = createContext();

export const LocationsProvider = ({ children }) => {
    const [locationsData, setLocationsData] = useState({
        regions: [],
        cities: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                // Fetch countries and regions in parallel
                const [regionsRes, citiesRes] = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/locations/regions`),
                    fetch(`${process.env.REACT_APP_API_URL}/locations/cities`)
                ]);

                if (!regionsRes.ok || !citiesRes.ok) {
                    throw new Error("Failed to fetch locations data");
                }

                const regions = await regionsRes.json();
                const cities = await citiesRes.json();

                setLocationsData({
                    regions,
                    cities,
                    loading: false,
                    error: null
                });
            } catch (error) {
                console.error("Error fetching locations:", error);
                setLocationsData(prev => ({
                    ...prev,
                    loading: false,
                    error: error.message
                }));
            }
        };

        fetchLocations();
    }, []);

    return (
        <LocationsContext.Provider value={locationsData}>
            {children}
        </LocationsContext.Provider>
    );
};